import PropTypes from 'prop-types';
import {DataTypeProvider} from '@devexpress/dx-react-grid';

const ListFormatter = ({value}) => (
  <div>
    {value.map((team) => (
      <li key={team.name}>{team.name}</li>
    ))}
  </div>
);
const ListProvider = (props) => (
  <DataTypeProvider formatterComponent={ListFormatter} {...props} />
);

ListFormatter.propTypes = {
  value: PropTypes.array.isRequired,
};

export default ListProvider;
